module.exports = __webpack_public_path__ + "static/media/36-10.4265a1b1.mp3";